var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrismaPointStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 41,
    viewBox: "0 0 29 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4826,
    cy: 26.2382,
    r: 10,
    transform: "rotate(65.5835 14.4826 26.2382)",
    fill: "#1C1C1C",
    stroke: "#B9986A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1506 31.2648L17.7766 23.0685C17.9666 22.7927 17.9994 22.4434 17.8639 22.1449L17.1822 20.6432C17.1539 20.5809 17.0868 20.5385 17.0166 20.5512C16.9296 20.5667 16.8751 20.6482 16.8905 20.7276C16.9213 20.8809 16.8884 21.043 16.7961 21.1777L11.1701 29.3739C10.9804 29.6504 10.948 29.9988 11.0835 30.2972C11.0835 30.2972 11.349 30.8823 11.7849 31.846C11.818 31.9189 11.9067 31.9507 11.9819 31.9165C12.0469 31.887 12.0832 31.8178 12.0675 31.7505C12.0288 31.5872 12.0547 31.4043 12.1506 31.2648Z",
    fill: "#B9986A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.483,
    cy: 20.0359,
    r: 10,
    transform: "rotate(32.2856 14.483 20.0359)",
    fill: "#1C1C1C",
    stroke: "#B9986A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2937 25.5161L15.4964 15.5768C15.5037 15.242 15.3394 14.932 15.0623 14.7569L13.6681 13.876C13.6102 13.8394 13.5309 13.8409 13.4792 13.89C13.415 13.9507 13.4142 14.0488 13.4706 14.1067C13.5805 14.2179 13.642 14.3714 13.6388 14.5347L13.4361 24.474C13.4294 24.8092 13.5935 25.1182 13.8706 25.2933C13.8706 25.2933 14.4138 25.6364 15.3071 26.2027C15.3748 26.2455 15.4664 26.2233 15.5105 26.1534C15.5487 26.0931 15.5409 26.0153 15.4909 25.9677C15.369 25.8525 15.2901 25.6854 15.2937 25.5161Z",
    fill: "#B9986A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.482,
    cy: 12.6415,
    r: 10,
    transform: "rotate(13.3557 14.482 12.6415)",
    fill: "#1C1C1C",
    stroke: "#B9986A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0294 17.5625L13.9967 8.09501C13.895 7.77589 13.639 7.53597 13.3201 7.46025L11.7155 7.0793C11.6489 7.06348 11.5743 7.09057 11.5414 7.15378C11.5003 7.23207 11.5314 7.32515 11.6036 7.3616C11.7435 7.43112 11.8516 7.55638 11.9015 7.71187L14.9342 17.1794C15.0366 17.4986 15.292 17.7377 15.611 17.8134C15.611 17.8134 16.2361 17.9618 17.2648 18.2076C17.3427 18.2261 17.4221 18.1754 17.4412 18.095C17.4577 18.0256 17.4252 17.9545 17.3624 17.9257C17.2097 17.8563 17.0809 17.7238 17.0294 17.5625Z",
    fill: "#B9986A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrismaPointStack);
export default __webpack_public_path__ + "static/media/prisma-point-stack.e429e7b7183cce1bd4da3b30884532d4.svg";
export { ForwardRef as ReactComponent };